import { render, staticRenderFns } from "./PayrollDetails.vue?vue&type=template&id=f605b514&scoped=true"
import script from "./PayrollDetails.vue?vue&type=script&lang=js"
export * from "./PayrollDetails.vue?vue&type=script&lang=js"
import style0 from "./PayrollDetails.vue?vue&type=style&index=0&id=f605b514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f605b514",
  null
  
)

export default component.exports